import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative w-full min-h-[600px] h-screen bg-black flex items-center overflow-hidden">
      {/* Background Overlay if needed for image background, but instructions specify solid black */}
      <div className="hero-overlay absolute inset-0 bg-black opacity-100 z-0"></div>

      <div className="container relative z-10 flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20">
        
        {/* Left Side: Patil Group Logo */}
        <div className="flex-shrink-0 animate-fade-in-left">
          <div className="relative w-[268px] h-[300px]">
             <img 
                src="/images/logo-hero.png"
                alt="Patil Group Logo"
                className="w-full h-full object-contain"
             />
          </div>
        </div>

        {/* Right Side: Text Content */}
        <div className="max-w-[600px] text-center md:text-left">
          <h2 className="text-white font-display font-bold text-[36px] leading-[1.2] mb-6 tracking-tight animate-fade-in-left">
            BASUPRA EXIM INTERNATIONAL, INDIA
          </h2>
          
          <div className="mb-10 animate-fade-in-right">
            <p className="text-white text-[16px] leading-[1.6] font-body">
              We help people globally to nurture prosperity in agriculture, food and
              engineering sector with our Indian technologies.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center md:items-start gap-4 animate-fade-in-up">
            <Link 
              to="/projects" 
              className="btn-professional inline-flex items-center justify-center px-10 py-3.5 border border-white text-white text-[14px] font-semibold uppercase tracking-wider hover:bg-white hover:text-black transition-colors min-w-[160px]"
            >
              Projects
            </Link>
            <Link 
              to="/services" 
              className="btn-professional inline-flex items-center justify-center px-10 py-3.5 bg-white text-[#17A2B8] text-[14px] font-semibold uppercase tracking-wider hover:bg-[#17A2B8] hover:text-white transition-colors min-w-[160px]"
            >
              Services
            </Link>
          </div>
        </div>

      </div>
      
      {/* Decorative vertical lines or grid dots could go here if they existed in the original, 
          but based on screenshots it's a clean black background hero. */}
    </section>
  );
};

export default Hero;
